module.exports = __webpack_public_path__ + "static/media/contract1.d463299d.png";